export enum ZoomLevel {
    FLUID = 'FLUID',
    FIT_TO_WIDTH = 'FIT_TO_WIDTH',
    FIT_TO_CONTAINER = 'FIT_TO_CONTAINER',
    FIT_TO_NATIVE = 'FIT_TO_NATIVE',
}
